import { v4 as uuidv4 } from 'uuid';
import { postTypesArr } from '../Constants/Variables';
const axios = require('axios').default;
const asanaAPIToken = "1/531187398242434:8494c3353db0bcb6fe40b6d7809a4a7d";
const asanaWallTasksProjectId = "1194088099249937";

//a function that checks if the given date occurs today(i.e - returns a boolean)
const isToday = givenDate => {
    var date = new Date(givenDate);
    var today = new Date();
    return date.getDay === today.getDay && date.getMonth === today.getMonth && date.getFullYear === today.getFullYear;
}

const truncateString = (str, num) => {
    if (str.length <= num) {
        return str
    }
    return str.slice(0, num) + '...';
}

const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}

function loadFirebaseImageBlob(filepath, storageRef) {

    return new Promise(function (resolve, reject) {
        try {

            storageRef.child(filepath).getDownloadURL()
                .then((url) => {

                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onerror = function () { reject("Network error.") };
                    xhr.onload = (event) => {
                        var blob = xhr.response;
                        resolve(blob)
                    };
                    xhr.open('GET', url);
                    xhr.send();

                })
                .catch((error) => {
                    // Handle any errors
                });
        }
        catch (err) { reject(err.message) }
    });
}

const convertFirebaseTimestampToDate = (timestamp) => {
    return new Date((timestamp.seconds * 1000) + (timestamp.nanoseconds / 1000 / 1000));
}

const GetOffice365DataByEmail = async (email) => {
    var result;
    await axios.post('https://prod-150.westeurope.logic.azure.com:443/workflows/849be9966fe340aa8fa30fce811764fd/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=fyOhsv259bkEtDwjsoa_-CsoguZWHeufCfaoIlXtgq0', {
        email
    })
        .then(function (response) {
            result = response.data;
        })
        .catch(function (error) {
            result = error;
        });
    return result;
}

const GetMultipleOffice365DataByEmail = async (emailsArr) => {

    var requestsArr = [];
    var result;

    emailsArr.forEach(email => {
        const request = axios.post('https://prod-150.westeurope.logic.azure.com:443/workflows/849be9966fe340aa8fa30fce811764fd/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=fyOhsv259bkEtDwjsoa_-CsoguZWHeufCfaoIlXtgq0', {
            email
        });
        requestsArr.push(request);

    });

    await axios.all([...requestsArr]).then(axios.spread((...responses) => {
        result = responses.filter(response => response.status === 200).map((response) => { return response.data });
        // use/access the results 
    })).catch(errors => {
        // react on errors.
    });

    return result;
}

const getAsanaWallTasksByProjectId = async (projectId) => {

    var result;
    await axios({
        method: 'get',
        url: 'https://app.asana.com/api/1.0/projects/' + projectId + '/tasks?opt_pretty=true&opt_fields=memberships.(section|project).name,name,notes',
        headers: { 'Authorization': 'Basic ' + btoa(asanaAPIToken + ":") }
    }).then(function (response) {
        var data = response.data.data;
        // console.log(data)

        var asanaTasksObjArr = [];
        data.forEach(task => {
            var theWallProjectSectionData = task.memberships.filter((item) => { return item.project.gid === projectId })[0];
            var obj = {
                id: task.gid,
                title: task.name,
                description: task.notes,
                status: theWallProjectSectionData.section.name
            }
            asanaTasksObjArr.push(obj);
        });
        result = asanaTasksObjArr;
    })
        .catch(function (error) {
            console.log(error);
            result = error;
        })
        .then(function () {
            // always executed
        });
    return result;

}

const getAsanaWallTaskById = async (taskId) => {
    var result;
    await axios({
        method: 'get',
        url: 'https://app.asana.com/api/1.0/tasks/' + taskId + '?opt_pretty=true&opt_fields=memberships.(section|project).name,name,notes,completed,assignee.name,due_on,start_on',
        headers: { 'Authorization': 'Basic ' + btoa(asanaAPIToken + ":") }
    }).then(function (response) {
        var task = response.data.data;
        console.log(task)
        var theWallProjectSectionData = task.memberships.filter((item) => { return item.project.gid === asanaWallTasksProjectId })[0];
        var obj = {
            id: task.gid,
            title: task.name,
            description: task.notes,
            status: theWallProjectSectionData ? theWallProjectSectionData.section.name : (task.completed ? "Done" : "In Progress"),
            assignee: task.assignee ? {
                gid: task.assignee.gid,
                name: task.assignee.name,
            } : "",
            start_date: task.start_on ? task.start_on : "",
            due_date: task.due_on ? task.due_on : "",
        }
        result = obj;
    })
        .catch(function (error) {
            console.log(error);
            // result = error;
        })
        .then(function () {
            // always executed
        });
    return result;
}

const getAsanaProjectTasksById = async (projectId) => {
    var result = [];
    await axios({
        method: 'get',
        url: 'https://app.asana.com/api/1.0/projects/' + projectId + '/tasks?opt_pretty=true&opt_fields=memberships.(section|project).name,name,notes,completed,assignee.name,due_on,start_on',
        headers: { 'Authorization': 'Basic ' + btoa(asanaAPIToken + ":") }
    }).then(function (response) {
        var tasks = response.data.data;
        tasks.forEach(task => {
            var theWallProjectSectionData = task.memberships.filter((item) => { return item.project.gid === asanaWallTasksProjectId })[0];
            var obj = {
                id: task.gid,
                title: task.name,
                description: task.notes,
                status: theWallProjectSectionData ? theWallProjectSectionData.section.name : (task.completed ? "Done" : "In Progress"),
                assignee: task.assignee ? {
                    gid: task.assignee.gid,
                    name: task.assignee.name,
                } : "",
                start_date: task.start_on ? task.start_on : "",
                due_date: task.due_on ? task.due_on : "",
            }
            result.push(obj);
        });
    })
        .catch(function (error) {
            console.log(error);
            // result = error;
        })
        .then(function () {
            // always executed
        });
    return result.filter(item => item.assignee);
}

const convertOldDBtoNewDB = async (oldDB) => {
    var newDB = [];
    oldDB.forEach(async oldpost => {
        var postId = uuidv4();
        var typeIndex = oldpost.tag === "Environment" || oldpost.tag === "Office Evnironment" ? 2 : (oldpost.tag === "Product Suggestions" || oldpost.tag === "Operational Feedback" ? 1 : (oldpost.tag === "Product Suggestions" ? 3 : 0));
        var typeName = postTypesArr[typeIndex];
        var oldpostLikesKeys = oldpost.likes ? Object.keys(oldpost.likes) : [];
        var oldpostLikesVals = oldpost.likes ? Object.values(oldpost.likes) : [];
        var likes = [];
        var likesUserObj;
        var oldComments = oldpost.comments ? oldpost.comments : [];
        var comments = [];
        var commentsObj;
        var asanaTask = "";

        if (oldpost.asanaId) {
            await getAsanaWallTaskById(oldpost.asanaId).then(data => {
                asanaTask = data;
            })
        }

        if (oldpostLikesKeys.length) {
            oldpostLikesKeys = oldpostLikesKeys.map((email) => {
                var com = email.slice(email.length - 3);
                var emailStart = email.slice(0, email.length - com.length);
                var newEmail = emailStart + "." + com;
                return newEmail
            }).filter((val, i) => { return oldpostLikesVals[i] === "true" });
            // console.log(oldpostLikesKeys)

            if (oldpostLikesKeys.length) {
                await GetMultipleOffice365DataByEmail(oldpostLikesKeys).then((responses) => {
                    if (responses) {
                        responses.forEach(async (data, i) => {
                            if (oldpostLikesVals[i]) {
                                likesUserObj = {
                                    user: {
                                        name: data.name,
                                        uid: data.uid
                                    }
                                }
                                likes.push(likesUserObj);
                            }
                        });
                    }

                });
            }

        }

        if (oldComments.length) {
            var commentUserEmailsArr = oldComments.map(comment => comment.email);
            await GetMultipleOffice365DataByEmail(commentUserEmailsArr).then((responses) => {
                if (responses) {

                    oldComments.forEach((comment, i) => {
                        var commentId = uuidv4();
                        commentsObj = {
                            id: commentId,
                            message: comment.description,
                            timestamp: comment.timestamp,
                            user: {
                                name: responses[i].name,
                                uid: responses[i].uid
                            }
                        }
                        comments.push(commentsObj);
                    });
                }

            });
        }

        var newpost = {
            asana: asanaTask,
            id: postId,
            timestamp: oldpost.createdAt,
            visibility: oldpost.public,
            type: {
                index: typeIndex,
                name: typeName
            },
            // user: {
            //     uid: account.accountIdentifier,
            //     name: account.name
            // },
            message: oldpost.description,
            likes,
            comments
        };
        newDB.push(newpost);
    });
    console.log("convertedDB: ", newDB);
}

const isUserAllowed = (role, action) => {

    //permissions settings object
    var permissions = {
        // editDayPlan: ["Supervisor"],
        viewPrivatePosts: ["Admin", "Moderator"],
        deletePosts: ["Admin", "Moderator"],
        deletePostComments: ["Admin", "Moderator"],
        editPostType: ["Admin", "Moderator"],
        linkPostTasks: ["Admin", "Moderator"],
    }

    //returning the boolean value based on the user role and action selected
    return permissions[action].includes(role);
}

const testingUsersAccess = (email) => {
    var allowedUsers = [
        "ozhe@payoneer.com",
        "andrewdu@payoneer.com"
    ]
    return allowedUsers.includes(email);
}

const sortByStatus = (a, b) => {
    // Use toUpperCase() to ignore character casing
    const objA = a.status.toUpperCase();
    const objB = b.status.toUpperCase();

    let comparison = 0;
    if (objA > objB) {
        comparison = 1;
    } else if (objA < objB) {
        comparison = -1;
    }
    return comparison;
}

const sortByCreated = (a, b) => {
    // Use toUpperCase() to ignore character casing
    const objA = a.created;
    const objB = b.created;

    let comparison = 0;
    if (objA > objB) {
        comparison = 1;
    } else if (objA < objB) {
        comparison = -1;
    }
    return comparison;
}

const sortByDuedate = (a, b) => {
    // Use toUpperCase() to ignore character casing
    const objA = a.due_date.toUpperCase();
    const objB = b.due_date.toUpperCase();

    let comparison = 0;
    if (objA > objB) {
        comparison = 1;
    } else if (objA < objB) {
        comparison = -1;
    }
    return comparison;
}

export {
    isToday,
    truncateString,
    titleCase,
    loadFirebaseImageBlob,
    convertFirebaseTimestampToDate,
    isUserAllowed,
    getAsanaWallTasksByProjectId,
    getAsanaWallTaskById,
    getAsanaProjectTasksById,
    testingUsersAccess,
    convertOldDBtoNewDB,
    GetOffice365DataByEmail,
    GetMultipleOffice365DataByEmail,
    sortByStatus,
    sortByDuedate,
    sortByCreated
};
